<div class="bar">
  <div class="title">Список сотрудников</div>
  <ico ico="person_add_24" (click)="add()" title="Создать сотрудника"></ico>
</div>
<users-list-item [user]="user" [listId]="listId" *ngFor="let user of users"></users-list-item>
